import { render, staticRenderFns } from "./winningBidAnnouncement.vue?vue&type=template&id=32a6cbbc&scoped=true"
import script from "./winningBidAnnouncement.vue?vue&type=script&lang=js"
export * from "./winningBidAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./winningBidAnnouncement.vue?vue&type=style&index=0&id=32a6cbbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a6cbbc",
  null
  
)

export default component.exports